import { Flex, Input, Text } from '@chakra-ui/react';
import { CustomErrorIcon } from '../../../../theme/icons/CustomErrorIcon';

interface FieldRowProps {
  label: string;
  value: string;
  error?: string;
  placeholder?: string;
  inputMode?: 'text' | 'decimal' | 'numeric';
  isHighlighted?: boolean;
  onFocus?: () => void;
  onChange: (value: string) => void;
}

const FieldRow = ({
  label,
  value,
  error,
  placeholder,
  inputMode,
  isHighlighted,
  onFocus,
  onChange,
}: FieldRowProps) => (
  <>
      <Flex
        bg="rgba(228, 228, 228, 0.5)"
        borderRadius="5px"
        h="35px"
        overflow="hidden"
        align="center"
      >
        <Flex
          bg="white"
          borderLeftRadius="3px"
          h="31px"
          w="160px"
          flexShrink={0}
          align="center"
          px="12px"
          ml="2px"
        >
          <Text
            textStyle="bodyFamilyRegular"
            fontSize="14px"
            color="black"
            noOfLines={1}
          >
            {label}
          </Text>
          <Text color="red" fontSize="12px" ml="1px">
            *
          </Text>
        </Flex>
        <Input
          variant="unstyled"
          textStyle="bodyFamilyRegular"
          fontSize="14px"
          color="black"
          px="14px"
          h="full"
          value={value}
          placeholder={placeholder}
          inputMode={inputMode}
          onFocus={onFocus}
          onChange={(e) => onChange(e.target.value)}
        />
      </Flex>
    {error && (
      <Flex align="center" gap={1.5} pl={2} mt={2}>
        <CustomErrorIcon boxSize="12px" color="#E53E3E" />
        <Text fontSize="12px" color="#E53E3E">
          {error.includes(': ') ? error.split(': ').slice(1).join(': ') : error}
        </Text>
      </Flex>
    )}
  </>
);

export default FieldRow;
